"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateYearsOptions = exports.StudyYearSelection = void 0;
var _react = require("react");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _studyYear = require("../../utilities/studyYear");
var _dates = require("../../utilities/dates");
var _Menu = require("../../UI/Menu");
var _Icon = require("../../UI/Icon");
var _Radio = require("../../UI/Radio");
var _List = require("../../Data/List");
var _StudyYearSelection = require("./StudyYearSelection.labels");
var _StudyYearSelection2 = _interopRequireDefault(require("./StudyYearSelection.styles"));
var _RangeDatePicker = require("../../UI/DateTimePickers/RangeDatePicker");
var _RadioGroup = require("../../UI/Radio/RadioGroup");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var generateYearsOptions = function generateYearsOptions(numOfYears, numOfSemesters) {
  var currentStudyYear = (0, _studyYear.getStudyYearDataByDate)(new Date(), numOfSemesters);
  var yearsOptions = [currentStudyYear];
  for (var i = 1; i < Math.max(numOfYears, 1); i++) {
    yearsOptions.push((0, _studyYear.getStudyYearData)(currentStudyYear.startYear - i, numOfSemesters));
  }
  return yearsOptions;
};
exports.generateYearsOptions = generateYearsOptions;
var StudyYearSelection = function StudyYearSelection(props) {
  var _studyYearsOptions, _currentCustomRangeDa, _currentCustomRangeDa2;
  var _props$numOfYears = props.numOfYears,
    numOfYears = _props$numOfYears === void 0 ? 3 : _props$numOfYears,
    _props$numOfSemesters = props.numOfSemesters,
    numOfSemesters = _props$numOfSemesters === void 0 ? 2 : _props$numOfSemesters,
    semesterLabel = props.semesterLabel,
    buttonLabel = props.buttonLabel,
    btnProps = props.btnProps,
    _props$enableCustomDa = props.enableCustomDates,
    enableCustomDates = _props$enableCustomDa === void 0 ? false : _props$enableCustomDa,
    userSelection = props.userSelection,
    onChange = props.onChange;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext2 = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    language = _useContext2.language;
  var getLabel = (0, _hooks.useLabels)({
    labels: _StudyYearSelection.labels
  });
  var styles = (0, _StudyYearSelection2.default)(isMobileView);
  var studyYearsOptions = (0, _react.useMemo)(function () {
    return generateYearsOptions(numOfYears, numOfSemesters);
  }, [numOfYears, numOfSemesters]);
  var defaultUserSelection = (0, _react.useMemo)(function () {
    return {
      isCustomRangeDates: false,
      year: studyYearsOptions[0]
    };
  }, [studyYearsOptions]);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    currentUserSelection = _useState2[0],
    setCurrentUserSelection = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    currentCustomRangeDates = _useState4[0],
    setCurrentCustomRangeDates = _useState4[1];
  var getSemesterName = (0, _react.useCallback)(function (semesterKey) {
    var semesterText = semesterLabel !== null && semesterLabel !== void 0 && semesterLabel.length ? semesterLabel : getLabel('semester');
    return "".concat(semesterText, " ").concat(getLabel(semesterKey.toUpperCase()));
  }, [semesterLabel, getLabel]);
  var buildAnchorText = (0, _react.useCallback)(function () {
    var anchorText = '';
    var validUserSelection = userSelection !== null && userSelection !== void 0 ? userSelection : defaultUserSelection;
    if (validUserSelection !== null && validUserSelection !== void 0 && validUserSelection.isCustomRangeDates && validUserSelection !== null && validUserSelection !== void 0 && validUserSelection.customRangeDates) {
      var dateFormat = '{day}/{month}/{year}';
      var customRangeDates = validUserSelection.customRangeDates;
      anchorText = "".concat((0, _dates.formatDate)(customRangeDates.startDate, dateFormat), " - ").concat((0, _dates.formatDate)(customRangeDates.endDate, dateFormat));
    } else {
      var studyYear = validUserSelection === null || validUserSelection === void 0 ? void 0 : validUserSelection.year;
      anchorText = (language === 'he' ? studyYear === null || studyYear === void 0 ? void 0 : studyYear.jewishTitle : studyYear === null || studyYear === void 0 ? void 0 : studyYear.title) + ' ';
      if (validUserSelection !== null && validUserSelection !== void 0 && validUserSelection.semester) {
        anchorText += getSemesterName(validUserSelection.semester);
      }
    }
    return anchorText;
  }, [language, userSelection, defaultUserSelection, getSemesterName]);
  var handleUserSelection = function handleUserSelection(userSelectionData) {
    setCurrentUserSelection(_objectSpread(_objectSpread({}, userSelectionData), {}, {
      customRangeDates: userSelection === null || userSelection === void 0 ? void 0 : userSelection.customRangeDates
    }));
  };
  var handleCustomDatesChange = function handleCustomDatesChange(startDate, endDate) {
    setCurrentCustomRangeDates([startDate, endDate]);
    if (startDate) {
      setCurrentUserSelection({
        isCustomRangeDates: true,
        customRangeDates: {
          startDate: startDate,
          endDate: endDate !== null && endDate !== void 0 ? endDate : startDate
        }
      });
    }
  };
  var handleCancel = function handleCancel() {
    setCurrentUserSelection(userSelection !== null && userSelection !== void 0 ? userSelection : defaultUserSelection);
  };
  var handleConfirm = function handleConfirm() {
    if (onChange) {
      var _startDate = new Date();
      var _endDate = new Date();
      if (currentUserSelection !== null && currentUserSelection !== void 0 && currentUserSelection.isCustomRangeDates && currentUserSelection !== null && currentUserSelection !== void 0 && currentUserSelection.customRangeDates) {
        _startDate = currentUserSelection.customRangeDates.startDate;
        _endDate = currentUserSelection.customRangeDates.endDate;
      } else if (currentUserSelection !== null && currentUserSelection !== void 0 && currentUserSelection.year) {
        var _currentUserSelection, _currentUserSelection2;
        _startDate = currentUserSelection === null || currentUserSelection === void 0 ? void 0 : (_currentUserSelection = currentUserSelection.year) === null || _currentUserSelection === void 0 ? void 0 : _currentUserSelection.start;
        _endDate = currentUserSelection === null || currentUserSelection === void 0 ? void 0 : (_currentUserSelection2 = currentUserSelection.year) === null || _currentUserSelection2 === void 0 ? void 0 : _currentUserSelection2.end;
        if (currentUserSelection !== null && currentUserSelection !== void 0 && currentUserSelection.semester) {
          var _currentUserSelection3, _currentUserSelection4;
          _startDate = currentUserSelection === null || currentUserSelection === void 0 ? void 0 : (_currentUserSelection3 = currentUserSelection.year) === null || _currentUserSelection3 === void 0 ? void 0 : _currentUserSelection3.semesters[currentUserSelection.semester].start;
          _endDate = currentUserSelection === null || currentUserSelection === void 0 ? void 0 : (_currentUserSelection4 = currentUserSelection.year) === null || _currentUserSelection4 === void 0 ? void 0 : _currentUserSelection4.semesters[currentUserSelection.semester].end;
        }
      }
      _startDate.setHours(0, 0, 0, 0);
      _endDate.setHours(23, 59, 59, 999);
      onChange(currentUserSelection, _startDate, _endDate);
    }
  };
  (0, _react.useEffect)(function () {
    if (studyYearsOptions && studyYearsOptions.length > 0) {
      if (userSelection && (userSelection.customRangeDates || studyYearsOptions.find(function (year) {
        var _userSelection$year;
        return year.startYear === ((_userSelection$year = userSelection.year) === null || _userSelection$year === void 0 ? void 0 : _userSelection$year.startYear);
      }))) {
        setCurrentUserSelection(userSelection);
        if (userSelection.customRangeDates) {
          var _userSelection$custom;
          setCurrentCustomRangeDates([(_userSelection$custom = userSelection.customRangeDates) === null || _userSelection$custom === void 0 ? void 0 : _userSelection$custom.startDate, userSelection === null || userSelection === void 0 ? void 0 : userSelection.customRangeDates.endDate]);
        }
      } else {
        setCurrentUserSelection({
          year: studyYearsOptions[0]
        });
      }
    }
  }, [studyYearsOptions, userSelection]);
  if (!studyYearsOptions || studyYearsOptions.length === 0) {
    return null;
  }
  var menuBtnProps = _objectSpread(_objectSpread({
    view: 'outlined',
    color: 'basic',
    shape: isMobileView ? 'roundedRectangle' : 'ellipse'
  }, btnProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: buttonLabel ? buttonLabel : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-StudyYearSelection__anchor-btn'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: buildAnchorText()
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          name: "Caret",
          width: (btnProps === null || btnProps === void 0 ? void 0 : btnProps.size) === 'large' ? 22 : (btnProps === null || btnProps === void 0 ? void 0 : btnProps.size) === 'small' ? 14 : 18,
          height: (btnProps === null || btnProps === void 0 ? void 0 : btnProps.size) === 'large' ? 22 : (btnProps === null || btnProps === void 0 ? void 0 : btnProps.size) === 'small' ? 14 : 18,
          fillColor: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main
        })]
      })
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
    btnProps: menuBtnProps,
    defaultTitle: getLabel('schoolYear'),
    isBoxCenteredToAnchor: true,
    isWithActionButtons: true,
    onConfirm: handleConfirm,
    onCancel: handleCancel,
    isFullScreen: isMobileView,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-StudyYearSelection'],
      children: [!isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-StudyYearSelection__title'],
        children: getLabel('schoolYear')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-StudyYearSelection__year-options'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RadioGroup.RadioGroup, {
          display: "inline",
          children: [studyYearsOptions === null || studyYearsOptions === void 0 ? void 0 : studyYearsOptions.map(function (year) {
            var _currentUserSelection5;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio.Radio, {
              id: year.startYear.toString(),
              label: language === 'he' ? year.jewishTitle : year.title,
              isChecked: (currentUserSelection === null || currentUserSelection === void 0 ? void 0 : (_currentUserSelection5 = currentUserSelection.year) === null || _currentUserSelection5 === void 0 ? void 0 : _currentUserSelection5.startYear) === year.startYear,
              onClick: function onClick() {
                handleUserSelection({
                  isCustomRangeDates: false,
                  year: year
                });
              }
            }, year.startYear.toString());
          }), enableCustomDates && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio.Radio, {
            id: 'range',
            label: getLabel('anotherDate'),
            isChecked: currentUserSelection === null || currentUserSelection === void 0 ? void 0 : currentUserSelection.isCustomRangeDates,
            onClick: function onClick() {
              handleUserSelection({
                isCustomRangeDates: true
              });
            }
          }, 'range')]
        })
      }), (currentUserSelection === null || currentUserSelection === void 0 ? void 0 : currentUserSelection.year) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-StudyYearSelection__semester-options'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List, {
          children: Object.entries(currentUserSelection === null || currentUserSelection === void 0 ? void 0 : currentUserSelection.year.semesters).map(function (_ref) {
            var _currentUserSelection6;
            var _ref2 = _slicedToArray(_ref, 2),
              semesterKey = _ref2[0],
              semesterDates = _ref2[1];
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
              id: "cc-StudyYearSelection__semester-option--".concat(semesterKey),
              size: "small",
              isSelected: currentUserSelection && ((_currentUserSelection6 = currentUserSelection.semester) === null || _currentUserSelection6 === void 0 ? void 0 : _currentUserSelection6.toLowerCase()) === semesterKey.toLowerCase(),
              onClick: function onClick() {
                handleUserSelection({
                  isCustomRangeDates: false,
                  year: currentUserSelection === null || currentUserSelection === void 0 ? void 0 : currentUserSelection.year,
                  semester: semesterKey
                });
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: getSemesterName(semesterKey)
              })
            }, "cc-StudyYearSelection__semester-option--".concat(semesterKey));
          })
        })
      }), (currentUserSelection === null || currentUserSelection === void 0 ? void 0 : currentUserSelection.isCustomRangeDates) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-StudyYearSelection__custom-range-dates'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RangeDatePicker.RangeDatePicker, {
          minDate: studyYearsOptions === null || studyYearsOptions === void 0 ? void 0 : (_studyYearsOptions = studyYearsOptions[studyYearsOptions.length - 1]) === null || _studyYearsOptions === void 0 ? void 0 : _studyYearsOptions.start,
          maxDate: studyYearsOptions === null || studyYearsOptions === void 0 ? void 0 : studyYearsOptions[0].end,
          startDate: (_currentCustomRangeDa = currentCustomRangeDates === null || currentCustomRangeDates === void 0 ? void 0 : currentCustomRangeDates[0]) !== null && _currentCustomRangeDa !== void 0 ? _currentCustomRangeDa : undefined,
          endDate: (_currentCustomRangeDa2 = currentCustomRangeDates === null || currentCustomRangeDates === void 0 ? void 0 : currentCustomRangeDates[1]) !== null && _currentCustomRangeDa2 !== void 0 ? _currentCustomRangeDa2 : undefined,
          onChange: handleCustomDatesChange
        })
      })]
    })
  });
};
exports.StudyYearSelection = StudyYearSelection;